module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-user/view-user.component.scss
// module id = ./src/app/view-user/view-user.component.scss
// module chunks = main